import { useMatches } from 'react-router-dom';

interface RouteUiHandle {
  hideTabBar?: boolean;
}

export function useTabBarHidden(): boolean {
  const matches = useMatches();

  return matches.some((match) => {
    const handle = match.handle as RouteUiHandle | undefined;
    return handle?.hideTabBar === true;
  });
}
